module.exports = __webpack_public_path__ + "img/loading_studio.07a7cfe1.svg";